// CSS pixels are 1/96 inch, so this is the size an image of that many pixels has on paper
export const MM_PER_PIXEL = 25.4 / 96

// The size in mm to place an image on a page: its natural size when it fits, otherwise scaled down (keeping its
// shape) to fit. An image is never enlarged, as that would only blur it.
export const fitImageToPage = (widthPixels:number, heightPixels:number, pageWidthMm:number, pageHeightMm:number) => {
    const width = widthPixels * MM_PER_PIXEL
    const height = heightPixels * MM_PER_PIXEL
    const scale = Math.min(1, pageWidthMm / width, pageHeightMm / height)
    return { width: width * scale, height: height * scale }
}

// Where the next image goes on a page with a margin all round, going down the page from `current` (mm from the top;
// undefined for the top of the first page). It goes below the last one if it fits, otherwise at the top of a new page,
// never leaving the page it is on blank. One taller than a page is sliced: it starts at the top of a page and
// continues over as many as it needs.
export const placeOnPage = (current:number|undefined, imageHeight:number, pageHeight:number, margin:number) => {
    const top = margin
    const bottom = pageHeight - margin
    const start = current || top
    const atTop = start <= top
    const sliced = imageHeight > bottom - top
    const newPage = !atTop && (sliced || start + imageHeight > bottom)
    return { newPage, top: newPage ? top : start, sliced }
}
